import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { OpsCommand } from 'src/app/shared/graphql/generated/operations-mutations.generated';
import { PollingService } from 'src/lib/tcs-polling-service/polling.service';
import { MUTATION_SUCCESS, MutationRequest } from 'src/util/graphql/mutation-actions';

@Injectable({ providedIn: 'root' })
export class PassdownLogEffects {
  public fetchPassdownLogCountOnAcknowledge$: Observable<any> = createEffect(
    () =>
      this._actions$.pipe(
        ofType<MutationRequest>(MUTATION_SUCCESS),
        filter(
          (m) =>
            m.name === OpsCommand.AcknowledgePassdownLog ||
            m.name === OpsCommand.AddPassdownLog ||
            m.name === OpsCommand.UpdatePassdownLog ||
            m.name === OpsCommand.DeletePassdownLog,
        ),
        switchMap(() => this._polling.fetch({ passdownLogs: { canFetch: true } })),
      ),
    { dispatch: false },
  );
  constructor(private _polling: PollingService, private _actions$: Actions) {}
}
